import styled from 'styled-components';
import { media } from 'theme';
import { Space } from 'seedly-component-library';

export const BackgroundContainer = styled.div<{ isCommentOpen: boolean }>`
  ${props =>
    props.isCommentOpen &&
    `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0,0,0,0.4);
      z-index: 30;
    `}
`;

export const CommentContainer = styled.div<{
  isCommentOpen: boolean;
}>`
  position: fixed;
  z-index: 20;
  height: 90%;
  width: 100%;
  top: 0;
  background-color: white;
  border-top-left-radius: ${props => props.theme.spacing.lg};
  border-top-right-radius: ${props => props.theme.spacing.lg};
  visibility: ${props => (props.isCommentOpen ? 'visible' : 'hidden')};
  transition: transform 0.6s cubic-bezier(0.23, 1, 0.32, 1) 0s,
    opacity 0.6s cubic-bezier(0.23, 1, 0.23, 1) 0s;
  transform: ${props =>
    props.isCommentOpen ? 'translateY(86px)' : 'translateY(100%)'};
  overflow: auto;

  ${props => media.smallAndUp`
    position: fixed;
    width: ${props.theme.sizing.sm};
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    margin: 0 auto;
    margin-right: 0px;
    height: 100vh;
    border-radius: 0px;
    transform: ${props.isCommentOpen ? 'translateX(0)' : 'translateX(100%)'};
  `}
`;

export const OverlayHeader = styled(Space)`
  padding: ${props => `${props.theme.spacing.sm} ${props.theme.spacing.md}`};
`;

export const OverlayBody = styled(Space)<{ hasComments: boolean }>`
  padding: ${props => props.theme.spacing.md};
  padding-top: ${props => props.theme.spacing.xs};
  height: ${props => (props.hasComments ? 'auto' : '90%')};
`;
